import React from 'react';

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
}

const TableSkeleton: React.FC<TableSkeletonProps> = ({ rows = 10, columns = 6 }) => {
  return (
    <div className="animate-pulse">
      {/* Header skeleton */}
      <div className="grid grid-cols-6 gap-4 p-4 border-b border-slate-200 dark:border-slate-700">
        {Array.from({ length: columns }).map((_, index) => (
          <div key={index} className="h-4 bg-slate-200 dark:bg-slate-700 rounded"></div>
        ))}
      </div>

      {/* Rows skeleton */}
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div key={rowIndex} className="grid grid-cols-6 gap-4 p-4 border-b border-slate-200 dark:border-slate-700">
          {Array.from({ length: columns }).map((_, colIndex) => (
            <div
              key={colIndex}
              className={`h-4 bg-slate-200 dark:bg-slate-700 rounded ${
                colIndex === 0 ? 'w-3/4' :
                colIndex === 1 ? 'w-16' :
                colIndex === 2 ? 'w-20' :
                colIndex === 3 ? 'w-24' :
                colIndex === 4 ? 'w-16' :
                'w-20'
              }`}
            ></div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default TableSkeleton;